import axios from 'axios';
import appConfig from '../config/appConfig';

export const createUser = (body) => axios.post(`${appConfig.api.ENDPOINT}/users/`, body);
